import { DOCUMENT } from '@angular/common';
import { DestroyRef, inject } from '@angular/core';

/** Витрины обновляются в течение дня: данные старше этого перезапрашиваются. */
const MAX_AGE_MS = 5 * 60_000;

/** Обновляет устаревшие данные при возвращении на вкладку; живёт вместе с владельцем. */
export class DataFreshness {
  private loadedAt = Date.now();

  /** Создаётся в контексте внедрения: слушает возврат на вкладку. */
  constructor(private readonly reload: () => void) {
    const document = inject(DOCUMENT);

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        this.refreshIfStale();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    inject(DestroyRef).onDestroy(() =>
      document.removeEventListener('visibilitychange', onVisibilityChange),
    );
  }

  refreshIfStale(): void {
    if (Date.now() - this.loadedAt < MAX_AGE_MS) {
      return;
    }

    this.loadedAt = Date.now();
    this.reload();
  }
}
